import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Report\GetReportController::__invoke
* @see app/Http/Controllers/Report/GetReportController.php
* @route '/api/reports/{report}'
*/
const GetReportController = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetReportController.url(args, options),
    method: 'get',
})

GetReportController.definition = {
    methods: ["get","head"],
    url: '/api/reports/{report}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Report\GetReportController::__invoke
* @see app/Http/Controllers/Report/GetReportController.php
* @route '/api/reports/{report}'
*/
GetReportController.url = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { report: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { report: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            report: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        report: typeof args.report === 'object'
        ? args.report.id
        : args.report,
    }

    return GetReportController.definition.url
            .replace('{report}', parsedArgs.report.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Report\GetReportController::__invoke
* @see app/Http/Controllers/Report/GetReportController.php
* @route '/api/reports/{report}'
*/
GetReportController.get = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetReportController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Report\GetReportController::__invoke
* @see app/Http/Controllers/Report/GetReportController.php
* @route '/api/reports/{report}'
*/
GetReportController.head = (args: { report: string | number | { id: string | number } } | [report: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetReportController.url(args, options),
    method: 'head',
})

export default GetReportController